import AppConstants from "../constants/AppConstants";
import getSlug from "speakingurl";

var FileUtils = {
  getSanitizedFileInfo(file) {
    var fullname = file.name.toLowerCase();

    var ext = this.getExt(fullname);
    var name = fullname.substring(0, fullname.lastIndexOf("."));
    name = this.sanitizeName(name);

    var fullname = name + (ext.length > 0 ? "." + ext : "");
    return {
      originalName: file.name,
      name: name,
      ext: ext,
      filename: fullname,
      size: file.size,
    };
  },

  getExt(filename) {
    return filename.substr((~-filename.lastIndexOf(".") >>> 0) + 2);
  },

  sanitizeName(filename) {
    return getSlug(filename, { separator: "_" });
  },

  getAssetType(ext) {
    var type = AppConstants.ASSET_TYPE_FILE;
    var normalizedExt = ext ? ext.toLowerCase() : ext;

    if (AppConstants.ASSET_TYPE_IMAGE_EXTS.includes(normalizedExt)) {
      type = AppConstants.ASSET_TYPE_IMAGE;
    } else if (AppConstants.ASSET_TYPE_VIDEO_EXTS.includes(normalizedExt)) {
      type = AppConstants.ASSET_TYPE_VIDEO;
    } else if (AppConstants.ASSET_TYPE_AUDIO_EXTS.includes(normalizedExt)) {
      type = AppConstants.ASSET_TYPE_AUDIO;
    } else if (AppConstants.ASSET_TYPE_LOTTIE_EXTS.includes(normalizedExt)) {
      type = AppConstants.ASSET_TYPE_LOTTIE;
    }

    return type;
  },

  /**
   * Extracts file extension from filename with robust error handling.
   * Enhanced version of getExt with better edge case handling.
   * @param {string} filename - The filename to extract extension from
   * @returns {string} Lowercase file extension without dot, or empty string if none
   */
  getMediaExtension: (filename) => {
    if (!filename) return "";
    const lastDotIndex = filename.lastIndexOf(".");
    return lastDotIndex >= 0 ? filename.slice(lastDotIndex + 1).toLowerCase() : "";
  },

  /**
   * Generic file type validation function.
   * @param {File} file - The file to validate
   * @param {string[]} allowedExtensions - Array of allowed file extensions (without dots)
   * @param {string[]} [allowedMimePrefixes=[]] - Array of allowed MIME type prefixes
   * @returns {boolean} True if file matches any of the allowed types
   */
  isValidFileType: (file, allowedExtensions, allowedMimePrefixes = []) => {
    if (!file) return false;

    const extension = FileUtils.getMediaExtension(file.name);
    const hasValidExtension = allowedExtensions.includes(extension);
    const hasValidMime = allowedMimePrefixes.some((prefix) => file.type?.startsWith(prefix));

    return hasValidExtension || hasValidMime;
  },

  /**
   * Validates if a file is a supported image type.
   * Enhanced version with both extension and MIME type validation.
   * @param {File} file - The file to validate
   * @returns {boolean} True if file is a supported image
   */
  isImageFile: (file) => {
    return FileUtils.isValidFileType(file, AppConstants.ASSET_TYPE_IMAGE_EXTS);
  },

  /**
   * Converts a byte count to megabytes (binary, 1 MB = 1024 * 1024 bytes).
   * @param {number} bytes - Size in bytes
   * @returns {number} Size in MB (unrounded). Format with .toFixed() or Math.round() at the call site.
   */
  bytesToMb: (bytes) => bytes / 1024 / 1024,
};

export default FileUtils;
